/*
 * Size tokens.
 *
 * Use these for media queries, where CSS variables can't be used.
 */

export const ContentMaxWidth = '60rem';
